import React, { useEffect, useState } from "react";
import { getData, getImplantationPending } from "../services/apiCliente";
import DashboardDetails from "./dashboard-details";
import Pusher from "pusher-js";
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import env from '../services/env';

var pusher = new Pusher(env('REACT_APP_VIPERA_KEY'), {
    wsHost: env('REACT_APP_VIPERA_HOST'),
    httpHost: env('REACT_APP_VIPERA_HOST')
});
const channel = pusher.subscribe(env('REACT_APP_VIPERA_CHANNEL'));
export const UserContext = React.createContext(null);

const extractUsername = (cookie) => {
    if (cookie.user) {
        const email = cookie.user?.emailUsuario;
        return email.split('@')[0];
    }
}

const Dashboard = () => {
    const [cookies] = useCookies(['user']);
    const navigate = useNavigate();
    if (!cookies.user && env('REACT_APP_DEVELOP') !== 'true') {
        navigate('/', { replace: true });
    }

    const [user, setUser] = useState();
    const [backups, setBackups] = useState([]);
    const [updatedImplantation, setUpdatedImplantation] = useState();
    const [implantationPendingList, setImplantationPendingList] = useState([]);
    let implantationList = [];

    const getBackups = async () => {
        const response = await getData(cookies.user.emailUsuario)
            .then((response) => {
                return response;
            }).catch((error) => {
                console.log(error);
            });

        setBackups(response.data);
    };

    const getImplantationPendingList = () => {
        getImplantationPending(cookies.user.emailUsuario)
            .then((response) => {
                setImplantationPendingList(response.data);
            }).catch((error) => {
                console.log(error);
            });
    };

    const implantationUpdated = (implantation) => {
        implantationList = implantationPendingList.filter(item => item.id !== implantation.id);
        setImplantationPendingList(implantationList);
    }

    useEffect(() => {

        channel.bind(env('REACT_APP_VIPERA_EVENT_IMPLANTATION'), (data) => {
            setUpdatedImplantation(data);
        });

        getBackups();
        getImplantationPendingList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setUser(extractUsername(cookies));
    }, [cookies]);

    useEffect(() => {
        implantationUpdated(updatedImplantation);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updatedImplantation]);

    return (
        <div>
            {backups.length > 0 &&
                <UserContext.Provider value={user}>
                    <DashboardDetails clientes={backups} implantations={implantationPendingList} />
                </UserContext.Provider>
            }
        </div>
    );
};

export default Dashboard;
